<template>
  <div id="page-user-edit" class="p-base">
    <vs-alert
      color="danger"
      title="User Not Found"
      :active.sync="user_not_found"
    >
      <span>User record with id: {{ $route.params.id }} not found. </span>
    </vs-alert>
    <div v-if="ready" class="mt-4">
      <div id="page-user-view">
        <div id="user-data" v-if="user_data">
          <vx-card title="Compte client" class="mb-base">
            <div class="vx-row">
              <div class="vx-col w-full md:w-64 p-base">
                <div class="img-container mb-4 items-center">
                  <img
                    src="@/assets/images/logo/logo_original.png"
                    class="rounded w-full"
                  />
                </div>
              </div>

              <div class="vx-col flex-1" id="account-info-col-1">
                <table>
                  <tr>
                    <td class="font-semibold">Référence Client</td>
                    <td>{{ user_data.ref }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Prénom</td>
                    <td>{{ user_data.first_name }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Nom</td>
                    <td>{{ user_data.last_name }}</td>
                  </tr>
                </table>
              </div>

              <div class="vx-col flex-1" id="account-info-col-2">
                <table>
                  <tr>
                    <td class="font-semibold">Téléphone</td>
                    <td>{{ user_data.phone_number }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Date création</td>
                    <td>{{ user_data.createdAt | datemongoose(true) }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </vx-card>

          <div class="vx-row">
            <cards-page-client
              title="Analytics"
              :dataSource="clientData"
              :sections="client_data"
            ></cards-page-client>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardsPageClient from "@/components/custom/analytics/CardsPageClient.vue";

export default {
  components: {
    CardsPageClient,
  },
  data() {
    return {
      clientData: null,
      user_data: null,
      user_not_found: false,
      ready: false,
      client_data: [
        {
          icon: "UsersIcon",
          title: "Articles Disponibles",
          key: "availableCount",
        },
        {
          icon: "UsersIcon",
          title: "Articles en attente de paiement",
          key: "notPaidCount",
        },
        {
          icon: "ShoppingCartIcon",
          title: "Crédit",
          key: "credit",
          color: "danger",
        },
        {
          icon: "XIcon",
          title: "Articles retournés",
          key: "returnedCountClient",
          color: "danger",
        },
      ],
    };
  },
  methods: {},
  async beforeMount() {
    try {
      const user_id = this.$route.params.id;
      this.clientData = await this.$store.dispatch(
        "CLIENT_DATA_REQUEST",
        user_id
      );
      const user = await this.$store.dispatch("FETCH_CLIENT", user_id);
      this.user_data = user;
      this.ready = true;
    } catch (error) {
      this.user_not_found = true;
      this.ready = false;
    }
  },
};
</script>

<style lang="scss">
#avatar-col {
  width: 20rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }
}
</style>

